import { useQuery } from "@tanstack/react-query";
import { getMember } from "../api/admin";
import { GetMemberParams } from "../types/types";
const useGetMember = ({
  page,
  searchKey,
  area,
  sort,
  limit,
}: GetMemberParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "Member",
      `page-${page}`,
      `searchKey-${searchKey}`,
      `area-${area}`,
      `sort-${sort}`,
    ],
    queryFn: () => getMember({ page, searchKey, area, sort, limit }),
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isSuccess };
};

export default useGetMember;
